import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Login2 from "../pages/AuthenticationInner/Login2";
import Register1 from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import ForgetPwd2 from "../pages/AuthenticationInner/ForgetPassword2";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";
import { routes } from "./path";
import UserList from "pages/Master/User/UserList";
import TaskTitleList from "pages/Master/TaskTitles/TaskTitleList";
import LeadTypeList from "pages/Master/LeadType/LeadTypeList";
import TaskList from "pages/Task/TaskList";
import LeadList from "pages/Lead/LeadList";
import AppointmentList from "pages/Appointment/AppointmentList";
import ParcelList from "pages/Parcel/ParcelList";
import MakingList from "pages/Making/MakingList";
import CustomerAttendList from "pages/CustomerAttend/CustomerAttendList";
import HelpNeededList from "pages/HelpNeeded/HelpNeededList";
import AdditionalWorkList from "pages/AdditionalWork/AdditionalWorkList";
import ImprovementList from "pages/Improvement/ImprovementList";
import DcTaskList from "pages/DC/DcTaskList";
import DBBackup from "pages/DBBackup/DBBackup";
import TaskChartReport from "pages/Task Report/TaskChartReport";
import FabricList from "pages/Fabric/FabricList";
import RentMakingCreate from "pages/RentAndMaking/RentMakingCreate";
import Categories from "pages/Master/Categories/Categories";
import Occasions from "pages/Master/Occasions/Occasions";
import WhatsAppMessages from "pages/Master/WhatsAppMessage/WhatsAppMessage";
import UnbillList from "pages/RentAndMaking/UnbillList";
import SendMessage from "pages/SendMessage/SendMessage";
import UnBillChartReport from "pages/UnBillReport/UnBillChartReport";
import CustomerAttendChartReport from "pages/CustomerAttendReport/CustomerAttendChartReport";
import Vendors from "pages/Master/Vendors/Vendors";
import PurchaseList from "pages/Purchase/PurchaseList";
import HandWork from "pages/HandWork/HandWork";
import OtherCost from "pages/Master/OtherCost/OtherCost";
import Workers from "pages/Master/Workers/Workers";
import StitchingWorkers from "pages/Master/StitchingWorkers/StitchingWorkers";
import StitchingMasters from "pages/Master/StitchingMasters/StitchingMasters";
import HandWorkOrder from "pages/HandWorkOrder/HandWorkOrder";
import WorkerHoliday from "pages/Master/WorkerHoliday/WorkerHoliday";
import Setting from "pages/Setting/Setting";
import EmployeeLeave from "pages/Attendance/EmployeeLeave";
import EmployeeSalary from "pages/Attendance/EmployeeSalary";
import EmployeeAttendanceLog from "pages/Attendance/EmployeeAttendanceLog";
import EmployeeAdvanceLog from "pages/Attendance/EmployeeAdvanceLog";
import AttendanceUserList from "pages/Master/AttendanceUsers/AttendanceUserList";
import AttendanceMonthlyReport from "pages/Attendance Report/AttendanceMonthlyReport";
import AttendanceDailyReport from "pages/Attendance Report/AttendanceDailyRepot";
import Rackshelf from "pages/Master/Rackshelf/Rackshelf";
import Kha_KhaRackList from "pages/Kha_KhaRack/Kha_KhaRackList";
import Material_RackList from "pages/Material_Rack/Material_RackList";
import DrawRequirementList from "pages/DrawRequirement/DrawRequirementList";
import Size from "pages/Master/Size/Size";
import CuttingRequirementList from "pages/CuttingRequirement/CuttingRequirementList";

const authProtectedRoutes = [
  { path: routes.dashboard, component: <Dashboard /> },
  { path: routes.userList, component: <UserList /> },
  { path: routes.taskTitle, component: <TaskTitleList /> },
  { path: routes.leadType, component: <LeadTypeList /> },
  { path: routes.task, component: <TaskList /> },
  { path: routes.lead, component: <LeadList /> },
  { path: routes.appointment, component: <AppointmentList /> },
  { path: routes.parcel, component: <ParcelList /> },
  { path: routes.making, component: <MakingList /> },
  { path: routes.CustomerAttend, component: <CustomerAttendList /> },
  { path: routes.helpNeeded, component: <HelpNeededList /> },
  { path: routes.additionalWork, component: <AdditionalWorkList /> },
  { path: routes.improvement, component: <ImprovementList /> },
  { path: routes.dcHanging, component: <DcTaskList /> },
  { path: routes.dbBackup, component: <DBBackup /> },
  { path: routes.taskReport, component: <TaskChartReport /> },
  { path: routes.fabric, component: <FabricList /> },
  { path: routes.rentmakinglist, component: <UnbillList /> },
  { path: routes.rentmakingcreate, component: <RentMakingCreate /> },
  { path: routes.rentmakingupdate, component: <RentMakingCreate /> },
  { path: routes.categories, component: <Categories /> },
  { path: routes.occasion, component: <Occasions /> },
  { path: routes.whatsAppMessage, component: <WhatsAppMessages /> },
  { path: routes.sendMessgae, component: <SendMessage /> },
  { path: "/profile", component: <UserProfile /> },
  { path: routes.unBillReport, component: <UnBillChartReport /> },
  { path: routes.customerAttendReport, component: <CustomerAttendChartReport /> },
  { path: routes.vendors, component: <Vendors /> },
  { path: routes.purchaseBill, component: <PurchaseList /> },
  { path: routes.handWork, component: <HandWork /> },
  { path: routes.otherCost, component: <OtherCost /> },
  { path: routes.workers, component: <Workers /> },
  { path: routes.stitchingWorkers, component: <StitchingWorkers /> },
  { path: routes.stitchingMasters, component: <StitchingMasters /> },
  { path: routes.handWorkOrder, component: <HandWorkOrder /> },
  { path: routes.designerOrder, component: <HandWorkOrder /> },
  { path: routes.stitchingOrder, component: <HandWorkOrder /> },
  { path: routes.workerHoliday, component: <WorkerHoliday /> },
  { path: routes.setting, component: <Setting /> },
  { path: routes.leave, component: <EmployeeLeave /> },
  { path: routes.employeeSalary, component: <EmployeeSalary /> },
  { path: routes.attendanceLog, component: <EmployeeAttendanceLog /> },
  { path: routes.advanceLog, component: <EmployeeAdvanceLog /> },
  { path: routes.attendanceReport, component: <AttendanceMonthlyReport /> },
  { path: routes.attendanceUser, component: <AttendanceUserList /> },
  { path: routes.dailyAttendanceReport, component: <AttendanceDailyReport /> },
  { path: routes.rackshelf, component: <Rackshelf /> },
  { path: routes.khaKhaRack, component: <Kha_KhaRackList /> },
  { path: routes.materialRack, component: <Material_RackList /> },
  { path: routes.cuttingRequirement, component: <CuttingRequirementList /> },
  { path: "*", component: <Pages404 /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to={routes.dashboard} />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-login-2", component: <Login2 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/pages-register-2", component: <Register2 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/page-recoverpw-2", component: <Recoverpw2 /> },
  { path: "/pages-forgot-pwd", component: <ForgetPwd1 /> },
  { path: "/auth-forgot-pwd-2", component: <ForgetPwd2 /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/auth-lock-screen-2", component: <LockScreen2 /> },
  { path: "/page-confirm-mail", component: <ConfirmMail /> },
  { path: "/page-confirm-mail-2", component: <ConfirmMail2 /> },
  { path: "/auth-email-verification", component: <EmailVerification /> },
  { path: "/auth-email-verification-2", component: <EmailVerification2 /> },
  { path: "/auth-two-step-verification", component: <TwostepVerification /> },
  { path: "/auth-two-step-verification-2", component: <TwostepVerification2 /> },
];

export { authProtectedRoutes, publicRoutes };
